import React from 'react';
import ReactDOM from 'react-dom';
import { Manager, Popper, PopperProps } from 'react-popper';

type PopperPropsWithoutChildren = Omit<PopperProps<'offset'>, 'children'>;

// NOTE: We might have to be smarter with multiple instances of this. Perhaps
export function useTooltip(
	popperProps?: PopperPropsWithoutChildren
): [JSX.Element, (Tooltip: JSX.Element) => { onMouseOut: () => void; onMouseOver: (event: any) => void }] {
	const [activeTooltip, setActiveTooltip] = React.useState<JSX.Element | null>(null);
	const [activeRef, setActiveRef] = React.useState<any>(undefined);

	function setupTriggers(Tooltip: JSX.Element) {
		return {
			onMouseOver: (event: any) => {
				setActiveRef(event.target);
				setActiveTooltip(Tooltip);
			},
			onMouseOut: () => {
				setActiveRef(null);
				setActiveTooltip(null);
			},
		};
	}

	return [
		<Manager>
			{ReactDOM.createPortal(
				<Popper referenceElement={activeRef} placement="right" {...popperProps}>
					{({ ref, style, placement, arrowProps }) => (
						<div
							ref={ref}
							style={{
								// It looks like some of the blueprint components have z-index which means we also have to have z-index.
								// Ordinarily zIndex shouldn't be used
								zIndex: 1000,
								...style,
							}}
							data-placement={placement}
						>
							{activeTooltip}
							<div ref={arrowProps.ref} style={arrowProps.style} />
						</div>
					)}
				</Popper>,
				document.querySelector('#modal-container') as Element
			)}
		</Manager>,
		setupTriggers,
	];
}
